// 🔴 [현재] URL 쿼리(?welcome_coupon=1) 기반 트리거 + localStorage 디바이스 1회 차단.
//          customer-account-app 이 발급 시 customer.metafields.custom.welcome_coupon_issued_at 을 set 하므로,
//          후속 PR 에서 그 metafield 를 Liquid 로 내려 data-issued-at 으로 읽고
//          "metafield 있고 + 이전 노출 시점보다 새 발급"이면 노출하도록 교체 예정.
//          → 현재 쿼리 방식은 customer-account-app 이 발급 직후 redirect 로 ?welcome_coupon=1 을 붙여줘야 동작.
class WelcomeCouponPopup extends ModalDialog {
  static STORAGE_SHOWN = "welcome-coupon-popup-shown";

  constructor() {
    super();
    this.queryKey = this.dataset.queryKey || "welcome_coupon";
    this.queryValue = this.dataset.queryValue || "";
    this.attachExtraListeners();
  }

  attachExtraListeners() {
    this.querySelectorAll(".js-button-close").forEach((btn) => {
      btn.addEventListener("click", () => this.hide());
    });
  }

  connectedCallback() {
    super.connectedCallback();

    if (Shopify.designMode) {
      if (this.dataset.openInDesignMode === "true") this.show();
      return;
    }

    if (!this.queryMatches()) return;
    if (this.alreadyShown()) return;

    localStorage.setItem(WelcomeCouponPopup.STORAGE_SHOWN, Date.now().toString());
    this.show();
  }

  queryMatches() {
    const params = new URLSearchParams(window.location.search);
    if (!params.has(this.queryKey)) return false;
    if (this.queryValue === "") return true;
    return params.get(this.queryKey) === this.queryValue;
  }

  alreadyShown() {
    try {
      return localStorage.getItem(WelcomeCouponPopup.STORAGE_SHOWN) !== null;
    } catch (e) {
      return false;
    }
  }
}

customElements.define("welcome-coupon-popup", WelcomeCouponPopup);
